'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgProfile(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M5.998 0C7.686 0 9.06 1.422 9.06 3.227c0 1.382-.796 2.57-1.917 3.061 2.565.439 4.51 2.3 4.51 4.216 0 .962-.668 1.446-1.839 1.492L9.625 12H2.378C1.09 12 .35 11.517.35 10.504c0-1.915 1.944-3.777 4.505-4.217-1.116-.49-1.912-1.675-1.912-3.045C2.943 1.447 4.322 0 5.998 0zm0 7.578c-2.309 0-4.138 1.464-4.254 2.794l-.008.154-.002.003.032.014c.087.032.24.059.467.067l.145.002h7.247c.305 0 .505-.03.61-.068l.033-.015-.001-.003-.008-.154c-.116-1.33-1.947-2.794-4.261-2.794zm0-6.19c-.894 0-1.667.811-1.667 1.854 0 1.06.782 1.9 1.667 1.9.892 0 1.674-.842 1.674-1.915 0-1.049-.764-1.839-1.674-1.839z", id: "Profile_svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Profile_svg__a" })))));
}

module.exports = SvgProfile;
//# sourceMappingURL=Profile.js.map
